import React from 'react';
import EGaugeDashboard from '../components/EGaugeDashboard';
import { getSiteById } from '../config/sites';

const WillametteHS = () => {
  const siteConfig = getSiteById('willamette');
  return <EGaugeDashboard config={siteConfig} />;
};

export default WillametteHS;
